'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.horizontalCenter = exports.Icon = exports.withBaseIcon = undefined;

var _Icon = require('./Icon');

var _horizontalCenter = require('./horizontalCenter');

exports.withBaseIcon = _Icon.withBaseIcon;
exports.Icon = _Icon.Icon;
exports.horizontalCenter = _horizontalCenter.horizontalCenter;
exports.default = _Icon.Icon;


//////////////////
// WEBPACK FOOTER
// ./~/react-icons-kit/index.js
// module id = 491
// module chunks = 35783957827783 114276838955818